import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { mergeClasses } from '../../classify';
import Footer from '../Footer';
import Header from '../Header';
import defaultClasses from './main.css';
import MobileHeader from '../Header/mobileHeader';
import useScript from '@magento/peregrine/lib/hooks/useScript';
import { useStoreSwitcher } from '@magento/peregrine/lib/talons/Header/useStoreSwitcher';
import { useHistory, useLocation } from 'react-router-dom';
import Icon from '../Icon';
import { bool, shape, string } from 'prop-types';
import OrderConfirmationHeader from '../Header/orderConfirmationHeader';
import { useAppContext } from '@magento/peregrine/lib/context/app';
import PromoBar from '@magento/venia-ui/lib/components/PromoBar/promoBar';
import { Helmet } from "react-helmet-async";
import StoreCheckoutLocatorModal from "../CheckoutPage/BCheckoutStoreModal/storeCheckoutLocatorModal";
import { FormattedMessage } from "react-intl";
import { sendGTMContainer, sendGTMEvent } from "../../util/initGTM";
import { useScrollLock, useWindowSize } from "@magento/peregrine";
import { ChevronUp } from 'react-feather';
import { useHeader } from "@magento/peregrine/lib/talons/Header/useHeader";
import SpinTheWheel from "../SpinTheWheel";
var GTM_PAGE_VIEW_URLS_IGNORE_DUE_CUSTOM_EVENT = ['/cart', '/checkout', '/success'];
export var POPUP_POSITION = {
  web_landing: 'web_landing',
  cart_landing: 'cart_landing',
  checkout_landing: 'checkout_landing',
  checkout_payment: 'checkout_payment',
  checkout_coupon_sub_button: 'checkout_coupon_sub_button'
};
var Main = props => {
  var {
    children,
    isMasked,
    isPrerender
  } = props;
  var ref = useRef();
  var location = useLocation();
  var [{
    preferenceCookiesEnabled
  }] = useAppContext();
  var pathname = location.pathname;
  var isMobile = useWindowSize().innerWidth <= 1248;
  var {
    loadMenuHeader,
    getFormattedHeaderData,
    menuData
  } = useHeader({
    isMobile
  });

  //called once on very first render
  useEffect(() => {
    //loading menu nodes
    loadMenuHeader();
  }, []);
  useEffect(() => {
    if (!GTM_PAGE_VIEW_URLS_IGNORE_DUE_CUSTOM_EVENT.some(restrictedPath => pathname.includes(restrictedPath))) {
      sendGTMContainer({});
    }
  }, [pathname]);

  //should always be visible
  var navbar = true;
  var classes = mergeClasses(defaultClasses, props.classes);
  var [showNav, setShowNav] = useState('');
  var [showAnchor, setShowAnchor] = useState(false);
  var [{
    currentStore,
    openStoreModal,
    openSearchBar
  }, {
    setOpenStoreModal
  }] = useAppContext();
  var {
    currentStoreCode
  } = useStoreSwitcher();
  useScrollLock(openStoreModal || isMasked || openSearchBar);
  var rootClass = isMasked ? classes.root_masked : classes.root;
  var pageClass = isMasked ? classes.page_masked : classes.page;
  useScript({
    url: "//staticw2.yotpo.com/".concat(currentStoreCode === 'en' ? process.env.YOTPO_API_KEY_EN : process.env.YOTPO_API_KEY_FR, "/widget.js"),
    type: 'text/text'
  });
  useEffect(() => {
    var observer = new IntersectionObserver(entry => {
      if (ref && ref.current) {
        //nav bar should always be visible as per client
        //setNavbar(entry[0].isIntersecting);
        setShowAnchor(!entry[0].isIntersecting);
      }
    }, {
      root: null,
      rootMargin: '0px 0px 1px 0px',
      threshold: 0.8
    });
    if (ref && ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (ref && ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref]);
  var anchorTopHandler = useCallback(() => {
    window.scrollTo({
      behavior: 'smooth',
      left: 0,
      top: 0
    });
    sendGTMEvent({
      eventCategory: 'checkout step 1 - cart',
      eventAction: 'go to top button',
      eventLabel: 'click',
      event: 'genericGAEvent'
    });
  }, []);
  useEffect(() => {
    window._learnq = window._learnq || [];
    window.klaviyoUserSignIn = customer => {
      _learnq.push(['identify', {
        '$email': customer.email,
        '$first_name': customer.firstname,
        '$last_name': customer.lastname
      }]);
    };
    window.kleviyoAddToCartEvent = addObject => {
      _learnq.push(["track", "Added to cart", addObject]);
    };
    window.kleviyoProductView = product => {
      var item = {
        "ProductName": product.name,
        "ProductID": product.id,
        "SKU": product.sku,
        "Categories": product.kleviyoCategories,
        "ImageURL": product.small_image,
        "URL": product.url_key,
        "Brand": product.brand,
        "Price": product.price_range.maximum_price.final_price.value,
        "CompareAtPrice": product.price_range.maximum_price.regular_price.value
      };
      _learnq.push(["track", "Viewed Product", item]);
    };
    window.klaviyoBeginCheckout = klaviyoBeginCheckoutPayload => {
      _learnq.push(["track", "Started Checkout", klaviyoBeginCheckoutPayload]);
    };
  }, []);
  useEffect(() => {
    //TODO: get back with the verification of PREFERENCE/NECESSARY choice
    //if(preferenceCookiesEnabled) {
    if (true) {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          "gtm.start": new Date().getTime(),
          event: "gtm.js"
        });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://load.measure.stokesstores.com/rjfljtep.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', process.env.GOOGLE_GTM_KEY);
    }
  }, [preferenceCookiesEnabled]);
  var header = () => {
    if (isMobile || isPrerender) {
      return /*#__PURE__*/React.createElement(MobileHeader, {
        isMobile: isMobile,
        navbar: navbar,
        getFormattedHeaderData: getFormattedHeaderData,
        isPrerender: isPrerender,
        menuData: menuData
      });
    }
    if (location.pathname === "/checkout" || location.pathname.includes('/success')) {
      return /*#__PURE__*/React.createElement(OrderConfirmationHeader, null);
    }
    return /*#__PURE__*/React.createElement(Header, {
      currentStore: currentStore,
      showNav: showNav,
      navbar: navbar,
      setShowNav: setShowNav,
      getFormattedHeaderData: getFormattedHeaderData
    });
  };
  var excludedPromoBarPath = ['cart', 'checkout', 'success', 'spin-the-wheel'];
  var history = useHistory();
  var currentPathComponents = useLocation().pathname.split('/');
  var excludePromoBar = useMemo(() => {
    var intersection = excludedPromoBarPath.filter(element => currentPathComponents.includes(element));
    if (intersection.length !== 0) {
      return false;
    }
    return true;
  }, [history.location]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SpinTheWheel, {
    placement: POPUP_POSITION.web_landing,
    isPopup: true
  }), /*#__PURE__*/React.createElement("main", {
    className: rootClass
  }, showAnchor && !location.pathname.includes("/checkout") && /*#__PURE__*/React.createElement("button", {
    className: classes.anchorTopButton,
    onClick: anchorTopHandler
  }, /*#__PURE__*/React.createElement(Icon, {
    src: ChevronUp
  }), /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "anchorTop.text",
    defaultMessage: "Top"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.anchorRef,
    ref: ref
  }), header(), excludePromoBar && /*#__PURE__*/React.createElement(PromoBar, {
    identifiers: "promobar_".concat(currentStoreCode)
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.mainContent
  }, showNav && /*#__PURE__*/React.createElement("div", {
    className: classes.overlay
  }), /*#__PURE__*/React.createElement("div", {
    className: pageClass
  }, children)), /*#__PURE__*/React.createElement(Footer, null), openStoreModal && /*#__PURE__*/React.createElement(StoreCheckoutLocatorModal, {
    setOpenStoreModal: setOpenStoreModal,
    productsInCart: [],
    isDetailedStock: true,
    infiniteScroll: true,
    forceAllStores: true
  })));
};
export default Main;
Main.propTypes = {
  classes: shape({
    page: string,
    page_masked: string,
    root: string,
    root_masked: string
  }),
  isMasked: bool
};